import { useEffect, useRef } from 'react';
import { isBusinessProfileRegistered } from '../constants/businessProfileStatusConstants';

export function useAutoPopulateForm({ profiles = [{}], customers = [{}], suppliers = [{}], documentType, setValue, getValues }) {
  const populated = useRef({
    billedBy: false,
    billedTo: false,
  });

  const prevDocType = useRef(documentType);

  useEffect(() => {
    if (prevDocType.current !== documentType) {
      setValue('accounting_supplier_party', null);
      setValue('accounting_customer_party', null);

      populated.current.billedBy = false;
      populated.current.billedTo = false;

      prevDocType.current = documentType;
      return;
    }

    if (documentType === 'SALES') {
      if (
        !populated.current.billedBy &&
        Array.isArray(profiles) &&
        profiles.length === 1 &&
        isBusinessProfileRegistered(profiles[0])
      ) {
        const existing = getValues('accounting_supplier_party');
        if (!existing) {
          setValue('accounting_supplier_party', profiles[0], {
            shouldValidate: true,
            shouldDirty: false,
          });
          populated.current.billedBy = true;
        }
      }

      if (!populated.current.billedTo && Array.isArray(customers) && customers.length === 1) {
        const existing = getValues('accounting_customer_party');
        if (!existing) {
          setValue('accounting_customer_party', customers[0], {
            shouldValidate: true,
            shouldDirty: false,
          });
          populated.current.billedTo = true;
        }
      }
    }
  }, [profiles, customers, suppliers, setValue, getValues]);
}
